import React from 'react';
import { Briefcase, Cog, Network, Zap } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';

const HomeServices = () => {
  const services = [
    {
      icon: Briefcase,
      title: 'Specialized Consulting',
      items: [
        'Strategic advisory support for Synthetic and Immersive Training',
        'Support to acquisition, system selection, and procurement processes',
        'Integration of heterogeneous and multinational training systems'
      ]
    },
    {
      icon: Cog,
      title: 'Programme & Project Management',
      items: [
        'End-to-end programme and project management support',
        'Coordination of multinational and multi-stakeholder initiatives',
        'Alignment of technical, operational, and organizational stakeholders'
      ]
    },
    {
      icon: Network,
      title: 'Synthetic Training Broker & Business Development',
      items: [
        'Shaping and enabling strategic partnerships and cooperation agreements',
        'Acting as a neutral broker between end users, industry, and institutions',
        'Supporting Research and Development of Synthetic Training ecosystems – Wargaming'
      ]
    },
    {
      icon: Zap,
      title: 'Fighter pilot training experience / High-Performance Leadership (loading)',
      items: [
        'Teamwork and communication through combat scenarios',
        'Rapid performance gains through debrief methodology',
        'Sharpened decision-making in dynamic environments',
        'Ready to become a \'Fighter Pilot\'?'
      ]
    }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-gray-900 to-black">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="text-white">Services &</span> <span className="text-red-500">Capabilities</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Virtual Red Air provides a comprehensive portfolio of services exploiting the full lifecycle of Synthetic Training capabilities.
          </p>
        </div>

        {/* Image embedded above the cards */}
        <div className="mb-12 max-w-5xl mx-auto">
          <img 
            src="https://customer-assets.emergentagent.com/job_vra-insights/artifacts/mpfygnxh_photo%203.1.png" 
            alt="Services and Capabilities"
            className="rounded-lg shadow-2xl w-full h-auto border border-red-900/30"
          />
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-7xl mx-auto">
          {services.map((service, index) => (
            <Card key={index} className="bg-black/50 border-red-900/30 backdrop-blur-sm hover:border-red-600/50 transition-all hover:shadow-lg hover:shadow-red-900/20">
              <CardHeader>
                <div className="flex items-center gap-4 mb-4">
                  <div className="p-4 bg-red-600/20 rounded-lg">
                    <service.icon className="h-8 w-8 text-red-500" />
                  </div>
                  <CardTitle className="text-2xl text-white">{service.title}</CardTitle>
                </div>
              </CardHeader>
              <CardContent>
                <ul className="space-y-3">
                  {service.items.map((item, idx) => (
                    <li key={idx} className="flex items-start gap-3 text-gray-300">
                      <span className="text-red-500 mt-1 flex-shrink-0">•</span>
                      <span className="text-sm leading-relaxed">{item}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeServices;